var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#18px_svg__clip0_6517_9196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6l-1.057 1.058 1.184 1.192H6.75v1.5h6.127l-1.184 1.185L12.75 12l3-3-3-3zm-9-2.25H9v-1.5H3.75c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5H9v-1.5H3.75V3.75z",
    fill: "#fff"
  }))));
}
export default Svg18Px;